var $jsCheck, $notVisible;

export default function scrollAnimation() {

    $jsCheck = $('.js-check');
    $notVisible = $('.notvisible');

    $(window).on('load', function () {
        checkView($jsCheck);
    });

    $(window).on('scroll', function () {
        makeVisible($jsCheck);
    });
}

function checkView(element) {
    element.each(function(i) {
        var top_of_element = $(this).offset().top;
        var bottom_of_element = top_of_element + $(this).outerHeight(true);

        var bottom_of_screen = $(window).scrollTop() + $(window).height();

        if ((bottom_of_screen > top_of_element) && (bottom_of_screen > bottom_of_element)) {
            // The element is visible, do something
            $(this).addClass('visible');
            $(this).animate({'opacity':'1'}, 400);
        }
        else {
            // The element is not visible, do something else
            $(this).addClass('notvisible');
        }
    });
}

function makeVisible(element) {
    element.each(function(i) {
        if( $(this).hasClass('notvisible')) {
            var bottom_of_object = $(this).position().top + $(this).outerHeight();
            var bottom_of_window = $(window).scrollTop() + $(window).height();
            /* Adjust the "200" to either have a delay or that the content starts fading a bit before you reach it  */
            bottom_of_window = bottom_of_window + 250;

            if( bottom_of_window > bottom_of_object ){
                $(this).animate({'opacity':'1'},500);

            }
        }
    });
}


// WEBPACK FOOTER //
// ./src/Resources/ui/js/scrollAnimation.js